import React, { useState } from "react"
import CustomButton from "../../Shared/CustomButton/CustomButton"
import { useChipStore } from "../../../stores/chipStore";
import "./Chips.css"


const Chips = React.memo(function Chips({ className = '', isDisabled }: { className: string, isDisabled: boolean }) {
  const [slctedChip, setSlctedChip] = useState(-1);
  const chips = useChipStore(c => c.chips);
  const selectedChip = useChipStore(c => c.selectedChip);
  const selectChip = useChipStore.getState().selectChip;

  function HandleChip(index: number) {
    setSlctedChip(index);
    selectChip(index)
  }


  return (
    <div className={className}>
      {
        chips.map((chip, cI) => {
          const noSelection = !selectedChip.price;
          const isSelected = slctedChip === cI;
          return (
            <CustomButton
              key={`chip-${cI}`}
              className={`chip-con ${isSelected && !isDisabled ? "selected-chip" : ""} ${noSelection ? "wave" : ""}`}
              style={noSelection ? { animationDelay: `${cI * 0.2}s` } : {}}
              onClick={() => HandleChip(cI)}
              disabled={isDisabled}
            >
              <img className="chip" src={chip.path} alt="chip" />
            </CustomButton>
          )
        })
      }
    </div>
  )
})

export default Chips;